import { Component, OnInit } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { EncryptionService } from './services/encryption-service/encryption.service';
import { PermissionService } from './services/role-permission/permission.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Patel Liquor Admin';

  constructor(
  ) { }


  ngOnInit(): void {

  }

}
